import React from "react";
import Rectangle from "../../../../../Assets/Images/Rectangle-blue.svg";

const SkillSelectNotifier = (props) => {
  return (
    <div className="notifier">
      <p>{props.Text}</p>{" "}
      <i className="feather-x" onClick={() => props.Close()}></i>
      <img alt="" src={Rectangle} />
    </div>
  );
};

export default SkillSelectNotifier;
